export default __webpack_public_path__ + "static/media/RuinsEdge.97407c99.jpg";